import React, { Component } from 'react';
import { Layout, Row, Col, Image } from 'antd';
import styles from  './index.module.scss'
import { useTranslation } from 'react-i18next';
import two from '../../images/two (1).png'
import beian from '../../images/beian.png'

const { Footer } = Layout;


function List() {
    const { t } = useTranslation();
  
    return (
        <Col>
            <Row className={styles.foot}>
                <Col span={19}>
                    <Col>
                        <Row>
                          {/* <Trans i18nKey="description.part1">
                          Shanghai black eye intelligent technology Limited Liability Company
                          </Trans> */}
                            <span className={styles.title}>
                                {t('code_19')}
                            </span>
                        </Row>
                        <Row>
                            {t('code_20')}
                        </Row>
                        <Row>
                            {t('code_21')}
                        </Row>
                    </Col>
                </Col>
                <Col>
                    <Row justify="center">
                        <Image width={126} height={126} preview={false} src={ two}/>
                    </Row>
                    <Row className={styles.font} justify="center">{t('code_23')}</Row>
                </Col>
            </Row>
            {/* <Row className={styles.FooterRow}>
                {t('description.partfour')}：沪ICP备18025222号-1
            </Row> */}
            <Row className={styles.FooterRow}>
                <div style={{ paddingRight: '20px' }}>
                    <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502018761"
                        style={{
                            display: 'inline-block', TextDecoder: 'none',
                            height: '20px'
                        }} rel="noreferrer">
                        <img src={beian} style={{ float: 'left' }} />
                        <p style={{ float: 'left', height: '20px', lineHeight: '20px', margin: '0px 0px 0px 5px', color: '#fff' }}>沪公网安备 31011502018761号</p></a>
                </div>
                <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noreferrer">沪ICP备18025222号-2</a>
            </Row>
        </Col>
    )
}

class FooterPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
       
        }
    }

    render() {
        return (
            <Footer className={styles.Footer}>
                <List />
            </Footer>
        )
    }
}
export default FooterPage;
